/**
 * @file 基本tabs组件
 * @author liudaoyu
 */

import React, { Component, PropsWithChildren } from 'react';
import TabItem, { ITabItemProps } from './tabItem';
import './tabs.scss';

export interface IProps extends PropsWithChildren<{}> {
    cls?: string;
    currentTabIndex?: number;
    theme?: 'start';
}

interface IState {
    tabIndex: number;
}

class Tabs extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            tabIndex: this.props.currentTabIndex || 0,
        };
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
        if (
            typeof nextProps.currentTabIndex !== 'undefined' &&
            nextProps.currentTabIndex !== this.props.currentTabIndex
        ) {
            this.onTabClick(nextProps.currentTabIndex);
        }
    }

    public onTabClick(index: number) {
        this.setState({
            tabIndex: index,
        });
    }

    public renderHeaderItem() {
        const headers: React.ReactNode[] = [];
        const children = this.props.children;
        if (!children) {
            return null;
        }

        React.Children.forEach(this.props.children, (item: any) => {
            headers.push(item);
        });

        return headers.map((item, index) => {
            const element = item as React.ReactElement<ITabItemProps>;
            if (!element) {
                return element;
            }
            return React.cloneElement(element, {
                key: index,
                index,
                active: this.state.tabIndex === index,
                onClick: () => {
                    if (element.props.onClick) {
                        element.props.onClick(index);
                    }
                    this.onTabClick(index);
                },
            });
        });
    }

    public render() {
        return (
            <div className={`tabs ${this.props.cls || ''} ${this.props.theme}`}>
                <ul className="tabs-header">{this.renderHeaderItem()}</ul>
            </div>
        );
    }
}

export { Tabs, TabItem };
